var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueLessThan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80531 13.208C8.69331 13.208 8.57331 13.176 8.44531 13.112C8.33331 13.032 8.23731 12.968 8.15731 12.92L1.07731 8.024C0.821313 7.848 0.637313 7.672 0.525313 7.496C0.429313 7.32 0.381313 7.128 0.381313 6.92V6.632C0.381313 6.408 0.429313 6.216 0.525313 6.056C0.637313 5.88 0.821313 5.704 1.07731 5.528L8.15731 0.631999C8.23731 0.584 8.33331 0.528 8.44531 0.464C8.57331 0.384 8.69331 0.344 8.80531 0.344C8.93331 0.344 9.04531 0.384 9.14131 0.464C9.23731 0.544 9.28531 0.664 9.28531 0.823999V1.232C9.28531 1.392 9.24531 1.528 9.16531 1.64C9.10131 1.736 8.97331 1.848 8.78131 1.976L1.84531 6.776L8.78131 11.576C8.97331 11.704 9.10131 11.824 9.16531 11.936C9.24531 12.032 9.28531 12.16 9.28531 12.32V12.728C9.28531 12.888 9.23731 13.008 9.14131 13.088C9.04531 13.168 8.93331 13.208 8.80531 13.208Z",
    fill: "#0080A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLessThan);
export default __webpack_public_path__ + "static/media/blueLessThan.096e7edfbdf6099d7c35d05cf74f4fa9.svg";
export { ForwardRef as ReactComponent };